import {Vue, Component} from 'vue-property-decorator';
import {AdminRoleData, AuthorityGroupData} from '@/types';
import {toI18n} from '@/utils/commonUtils';

@Component
export default class AdminRole extends Vue {
  public adminRoleData: AdminRoleData[] = [
    {value: '', label: this.toI18n('ADMIN_ADD_SELECT_ACCOUNT_TYPE')}, // 계정유형 선택
    {value: 'MASTER', label: this.toI18n('ADMIN_ADD_MASTER')}, // 마스터
    {value: 'NORMAL', label: this.toI18n('ADMIN_ADD_NORMAL')} // 일반
  ];

  public authorityGroupData: AuthorityGroupData[] = [
    {value: '0', label: this.toI18n('ADMIN_ADD_CHOOSE')} // 선택하세요
  ];

  public getAdminRoleLabel(adminRole: string): string {
    return (
      this.adminRoleData.find((admin: AdminRoleData): {} => {
        return admin.value === adminRole;
      }) || {value: '', label: this.toI18n('ADMIN_ADD_SELECT_ACCOUNT_TYPE')}
    ).label; // 계정유형 선택
  }

  public toI18n(needToI18nStr: string): string {
    return toI18n(this.$t(needToI18nStr));
  }

  public created(): void {
    this.$api.getAuthorityGroups({params: {page: 1, pageSize: 1000}}).then(({data: {contents}}: any): void => {
      const authorityGroupArray = contents.map(({no, name}: any): any => {
        return {value: no + '', label: jQuery.parseHTML(name)[0].textContent};
      });
      this.authorityGroupData = this.authorityGroupData.concat(authorityGroupArray);
    });
  }
}
